import { ActionType } from "../action-types";

const overviewReducer = (
  state = {
    themeColor: "#355F37",
    gradientPrimary: "#355F37",
    gradientSecondary: "#355F37",
    backGroundColor: "#deecd8",
    borderColor: "#CFAB48",
  },
  action
) => {
  switch (action.type) {
    case ActionType.SET_OVERVIEW:
      return action.payload;
    default:
      return state;
  }
};

export default overviewReducer;
